import type { OversightResultDocumentByDocumentIdResponseRow as OversightAssessmentDocumentOversightResultsByDocumentIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightAssessmentDocumentAssessmentResultsByDocumentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentDocumentAssessmentResultsByDocumentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentOversightResultsByDocumentIdArgs = {
  documentId: string;
};

export const useGetDocumentOversightResultsByDocumentId = createQueryHook<
  UseGetDocumentOversightResultsByDocumentIdArgs,
  OversightAssessmentDocumentOversightResultsByDocumentIdResponseRow[],
  GetOversightAssessmentDocumentAssessmentResultsByDocumentIdQuery
>({
  trpcQueryOptions: (trpc, { documentId }) =>
    trpc.frontend.assessment.oversightAssessmentDocumentAssessmentResultsByDocumentId.queryOptions(
      { documentId }
    ),
  mapTrpcDataToGraphQL: (data) => ({
    document_oversight_result: data,
  }),
  graphqlDocument:
    GetOversightAssessmentDocumentAssessmentResultsByDocumentIdDocument,
  graphqlVariables: ({ documentId }) => ({ ParentId: documentId }),
});
